var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "emo-video",
    },
    [
      _c(
        "div",
        { staticClass: "row-tips" },
        [
          _c("el-tag", { staticClass: "tips", attrs: { type: "warning" } }, [
            _c("div", [
              _vm._v(
                " 操作指引：上传图片，选择IP老师，输入视频文案内容，点击快速生成， 提醒：建议视频文案不超过50个字，文案内容越多容易导致视频生成失败 "
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "form",
          staticStyle: { "margin-top": "20px" },
          attrs: { model: _vm.form, "label-width": "105px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "图片上传:", prop: "imageUrl" } },
            [
              _c(
                "el-upload",
                {
                  ref: "upload",
                  staticClass: "upload-demo",
                  attrs: {
                    drag: "",
                    action: "#",
                    "http-request": _vm.fileChange,
                    "show-file-list": false,
                    "before-upload": _vm.beforeUpload,
                    accept: "image/jpg,image/jpeg,image/png",
                  },
                },
                [
                  !_vm.form.imageUrl
                    ? [
                        _c("i", { staticClass: "el-icon-upload" }),
                        _c("div", { staticClass: "el-upload__text" }, [
                          _vm._v(" 将文件拖到此处，或"),
                          _c("em", [_vm._v("点击上传")]),
                        ]),
                        _c("div", { staticClass: "el-upload__text m-t-10" }, [
                          _vm._v(_vm._s(_vm.tips)),
                        ]),
                      ]
                    : _c("el-image", {
                        attrs: {
                          fit: "contain",
                          src: _vm.form.imageUrl,
                          alt: "",
                        },
                      }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "IP老师:" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "w-200",
                  attrs: {
                    filterable: true,
                    placeholder: "请选择",
                    clearable: "",
                  },
                  on: { change: _vm.teacherChange },
                  model: {
                    value: _vm.form.teacherId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "teacherId", $$v)
                    },
                    expression: "form.teacherId",
                  },
                },
                _vm._l(_vm.teacherList, function (item) {
                  return _c(
                    "el-option",
                    {
                      key: item.teacherId,
                      attrs: { label: item.teacherName, value: item.teacherId },
                    },
                    [_vm._v(" " + _vm._s(item.teacherName) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "视频文案:" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: { maxRows: 5 },
                  resize: "none",
                  maxlength: "100",
                  placeholder: "请输入视频文案",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.form.videoContent,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "videoContent", $$v)
                  },
                  expression: "form.videoContent",
                },
              }),
            ],
            1
          ),
          _vm.isShowNext
            ? _c("el-form-item", { attrs: { label: "预计生成时间:" } }, [
                _c(
                  "div",
                  { staticClass: "flex flex-middle" },
                  [
                    _c(
                      "el-link",
                      { attrs: { underline: false, type: "primary" } },
                      [
                        _c("span", { staticStyle: { "margin-right": "2px" } }, [
                          _vm._v(_vm._s(_vm.form.generateTime)),
                        ]),
                        _vm._v(" 分钟 "),
                      ]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.taskId
            ? _c(
                "el-form-item",
                { attrs: { label: "视频:" } },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.taskStatus === "SUCCEEDED",
                        expression: "taskStatus === 'SUCCEEDED'",
                      },
                    ],
                    staticClass: "video_play",
                    attrs: { id: "shareVideoDetailPlay" },
                  }),
                  _c(
                    "el-empty",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.taskStatus !== "SUCCEEDED",
                          expression: "taskStatus !== 'SUCCEEDED'",
                        },
                      ],
                      staticStyle: { width: "200px", padding: "0" },
                      attrs: {
                        description:
                          _vm.taskStatus === "PENDING" ||
                          _vm.taskStatus === "RUNNING"
                            ? "生成中"
                            : "视频生成失败",
                      },
                    },
                    [
                      _c("template", { slot: "image" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/image/aigc/sczt-spdt.png"),
                            alt: "",
                          },
                        }),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticStyle: { "padding-right": "6px" },
          attrs: { gutter: 10, type: "flex", justify: "end" },
        },
        [
          !_vm.taskId
            ? [
                _c("el-button", { on: { click: _vm.audioTest } }, [
                  _vm._v("音频试听"),
                ]),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.generate } },
                  [_vm._v("确认生成")]
                ),
              ]
            : _vm._e(),
          _vm.taskStatus === "SUCCEEDED"
            ? [
                _c("el-button", { on: { click: _vm.restGenerate } }, [
                  _vm._v("重新生成"),
                ]),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.downLoadVideo },
                  },
                  [_vm._v("下载")]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("div", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.dialogVisible,
                expression: "dialogVisible",
              },
            ],
            staticClass: "dialogAudio el-dialog",
            on: { click: _vm.dialogVisibleClick },
          },
          [
            _c("div", { staticClass: "dialogAudio-title el-dialog__header" }, [
              _vm._v("音频预览"),
            ]),
            _c("div", { staticClass: "dialogAudio-body" }, [
              !_vm.isAudioCompleted && !_vm.isAudioError
                ? _c(
                    "div",
                    { staticClass: "generating" },
                    [
                      _c("div", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: true,
                            expression: "true",
                          },
                        ],
                        staticStyle: { width: "80px", height: "80px" },
                      }),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            "font-size": "16px",
                            color: "#333333",
                          },
                        },
                        [_vm._v("音频生成中")]
                      ),
                      _c("el-alert", {
                        staticClass: "m-t-12",
                        staticStyle: { width: "200px" },
                        attrs: {
                          title: "请勿关闭浏览器窗口！",
                          type: "warning",
                          description: "",
                          "show-icon": "",
                          closable: false,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isAudioCompleted && !_vm.isAudioError
                ? _c("div", { staticClass: "audio_sus" }, [
                    _c("img", { attrs: { src: _vm.audio_sus } }),
                    _c(
                      "p",
                      {
                        staticClass: "m-t-12",
                        staticStyle: {
                          "font-size": "16px",
                          color: "#333333",
                          "margin-top": "15px",
                        },
                      },
                      [_vm._v(" 音频已生成 ")]
                    ),
                    _c("audio", {
                      staticClass: "m-t-12",
                      staticStyle: { width: "100%" },
                      attrs: {
                        id: "audioForm",
                        src: _vm.form.audioUrl,
                        autoplay: "autoplay",
                        controls: "controls",
                        controlsList: "nodownload",
                      },
                    }),
                  ])
                : _vm._e(),
              _vm.isAudioError
                ? _c("div", { staticClass: "generating" }, [
                    _c("img", { attrs: { src: _vm.audio_err } }),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          color: "#333333",
                          "margin-top": "15px",
                        },
                      },
                      [_vm._v(" 音频生成失败 ")]
                    ),
                  ])
                : _vm._e(),
            ]),
            _c(
              "el-row",
              {
                staticClass: "dialogAudio-footer",
                attrs: { type: "flex", justify: "end" },
              },
              [
                _c("el-button", { on: { click: _vm.closeAudio } }, [
                  _vm._v("取 消"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }